import { useModals } from "web/hooks/modals"
import { Button } from "web/components"
import { useState } from "react"
import { Label } from "web/components/Form/Controls"

export const AddTileModal = ({ close, tileable }) => {
  const tile_types = tileable.tile_types
  const [mappingKey, setMappingKey] = useState(tile_types[0].key)

  const summarizableTiles = tile_types.filter(
    (tile) => tile.group === "Summary Tiles"
  )
  const tableTiles = tile_types.filter((tile) => tile.group === "Table Tiles")
  const richTextTiles = tile_types.filter((tile) => tile.group === "Text Tiles")
  const otherTiles = tile_types.filter((tile) => tile.group === "Other Tiles")
  const chartTiles = tile_types.filter((tile) => tile.group === "Charts")

  async function handleAddTile() {
    const tile = tile_types.find((tile) => tile.key === mappingKey)

    let data = {}
    if (tile.topic_id && tile.type) {
      data = { overview_tile: { topic_id: tile.topic_id, type: tile.type } }
    } else if (tile.topic_id) {
      data = { overview_tile: { topic_id: tile.topic_id } }
    } else if (tile.field_id) {
      data = { overview_tile: { field_id: tile.field_id, type: tile.type } }
    }

    await tileable.addTile(tile.route_suffix, data)

    close()
  }

  function handleTileTypeChange(e) {
    setMappingKey(e.target.value)
  }

  function options(tileMapping, label) {
    return (
      <optgroup label={label}>
        {tileMapping.map((tile) => (
          <option value={tile.key} key={tile.key}>
            {tile.label}
          </option>
        ))}
      </optgroup>
    )
  }

  return (
    <div className="h-full">
      <div className="modal-content-above-commands">
        <div className="grid-rows-l">
          <section className="grid-rows-l">
            <div className="grid gap-y-5">
              <div>
                <Label htmlFor="taskType" label="Tile Type" />
                <select
                  id="tileType"
                  name="tileType"
                  className="block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  value={mappingKey}
                  onChange={handleTileTypeChange}
                >
                  {summarizableTiles.length > 0 &&
                    options(summarizableTiles, summarizableTiles[0].group)}
                  {tableTiles.length > 0 &&
                    options(tableTiles, tableTiles[0].group)}
                  {richTextTiles.length > 0 &&
                    options(richTextTiles, richTextTiles[0].group)}
                  {chartTiles.length > 0 &&
                    options(chartTiles, chartTiles[0].group)}
                  {otherTiles.length > 0 &&
                    options(otherTiles, otherTiles[0].group)}
                </select>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="modal-commands">
        <div className="left-buttons">
          <Button onClick={handleAddTile}>Add</Button>
        </div>
      </div>
    </div>
  )
}

export default function useAddTileModal({ tileable }) {
  const { showModal } = useModals()

  return async function () {
    return await showModal({
      title: "Add Tile",
      fullScreen: false,
      widthPixels: 800,
      heightPixels: 400,
      component: ({ close }) => {
        return <AddTileModal close={close} tileable={tileable} />
      },
    })
  }
}
